import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { CameraIcon } from '@chegg-ui/theme';
import { UploadAvatarContainer, AvatarCircle } from '../styles';

var UploadAvatar = function UploadAvatar(_ref) {
  var renderAsButton = _ref.renderAsButton,
      props = _objectWithoutProperties(_ref, ["renderAsButton"]);

  return /*#__PURE__*/React.createElement(UploadAvatarContainer, _extends({}, props, {
    as: renderAsButton ? 'button' : 'div'
  }), /*#__PURE__*/React.createElement(AvatarCircle, {
    size: "large",
    "data-test": "avatarCircle"
  }, /*#__PURE__*/React.createElement(CameraIcon, {
    size: "large"
  })));
};

UploadAvatar.displayName = 'UploadAvatar';
export default UploadAvatar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/avatar/dist/esm/variants/UploadAvatar.js
// module id = 5576
// module chunks = 11